import { TeamModel } from "./Team.model";

export class Team extends TeamModel {
    // Add custom methods here
}
